import { Component, Input, OnInit } from '@angular/core';
import { ExecuteCommandService } from '../../services';
import { ExecutionSummaryDto, SummaryStageDto } from '../../data/CommandServiceDtos.generated';
import { faLink } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'project-cxplanner-summary',
  templateUrl: './project-cxplanner-summary.component.html',
  styleUrls: ['./project-cxplanner-summary.component.scss']
})
export class ProjectCxplannerSummmaryComponent implements OnInit {

  @Input() cxPlannerSummary: any;
  faCXPlannerLink = faLink;

  constructor(public executeCommandService: ExecuteCommandService) { }

  ngOnInit() {

  }

  gotoCXPlannerDashboard() {
    window.open("https://app.cxplanner.com/project/"+this.cxPlannerSummary.projectId+"/dashboard", "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-cxplanner-summary/project-cxplanner-summary.component.ts